'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactRouter = require('react-router');
var _OMGenericSelect = require('../OMComponents/OMGenericSelect/OMGenericSelect');var _OMGenericSelect2 = _interopRequireDefault(_OMGenericSelect);
var _LoadingResultsTitle = require('../LoadingResultsTitle/LoadingResultsTitle');var _LoadingResultsTitle2 = _interopRequireDefault(_LoadingResultsTitle);
var _formatObjectToQuery = require('../../utils/formatObjectToQuery');var _formatObjectToQuery2 = _interopRequireDefault(_formatObjectToQuery);
var _constants = require('../../constants');
var _components = require('../../components');
var _routerAdapter = require('../../helpers/routerAdapter');
var _PropertyListTopBlock = require('./PropertyListTopBlock.scss');var styles = _interopRequireWildcard(_PropertyListTopBlock);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PropertyListTopBlock = function (_Component) {_inherits(PropertyListTopBlock, _Component);function PropertyListTopBlock() {var _temp, _this, _ret;_classCallCheck(this, PropertyListTopBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      sortBy: 'created_at' }, _this.


    handleChange = function (sortBy) {
      if (sortBy !== _this.state.sortBy) {
        var params = (0, _formatObjectToQuery2.default)(_this.props.routeData);

        if (sortBy !== 'date') {
          var price = (sortBy === 'high price' ? '-' : '') + 'price';
          params.$sort = sortBy === 'created_at' ? '-created_at' : price;
        } else {
          params.$sort = '-search_date';
        }

        _this.setState({ sortBy: sortBy });var
        skip = _this.props.skip;
        var type = _this.props.routeData.location;
        _this.props.searchProperty({ params: Object.assign({}, params, { is_mobile: _this.props.isMobile }), skip: skip, type: type });
      }
    }, _this.

    updateRoute = function (type) {
      var route = (0, _routerAdapter.createUrl)(Object.assign({}, _this.props.routeData, { optionType: type }));
      _reactRouter.browserHistory.push({ pathname: route, state: Object.assign({}, _this.props.routeData, { optionType: type }) });
    }, _this.

    handleOptionChange = function (checked) {
      var optionType = checked ? _constants.optionTypes['rent-short'] : _constants.optionTypes.rent;
      _this.updateRoute(optionType);
    }, _this.

    renderPropertyOptionsSwitch = function () {var _ref =
      _this.props.routeData || {},optionType = _ref.optionType;
      var isCommercial = _this.props.routeData.location === 'commercial';
      var isNewHomes = _this.props.routeData.location === 'projects';
      var isForSale = optionType === _constants.optionTypes.buy;

      if (isCommercial || isNewHomes || isForSale) {return null;}
      var isRentShortChosen = optionType === _constants.optionTypes['rent-short'];

      return (
        _react2.default.createElement(_components.OMSwitch, {
          id: 'rent-type-switch',
          label: _this.props.translate('SEOsearch', 'switchToShortTerm').toString(),
          onChange: _this.handleOptionChange,
          isChecked: isRentShortChosen }));


    }, _this.

    renderSelect = function () {
      var opTypesValues = _constants.sortingOption.map(function (_ref2) {var title = _ref2.title,value = _ref2.value;return {
          label: _this.props.translate('sortingParams', title).toString(),
          selected: false,
          value: value };});


      return (
        _react2.default.createElement(_OMGenericSelect2.default, {
          options: opTypesValues,
          value: _this.state.sortBy,
          onChange: function onChange(_ref3) {var value = _ref3.value;return _this.handleChange(value);},
          className: styles.sortDropdown }));


    }, _this.

    renderH2Title = function () {
      var quantity = (_this.props.propertiesQuantity || 0) + (_this.props.projectsQuantity || 0);
      var sortedTitle = _this.props.translate('sortedResults').replace('quantity', quantity);

      return (
        _react2.default.createElement('h2', null,
          _react2.default.createElement('span', null, sortedTitle),
          _this.renderSelect()));


    }, _this.

    renderSortBlock = function () {return (
        _react2.default.createElement('div', { className: styles.searchTitle },
          _this.props.loading ?
          _react2.default.createElement(_LoadingResultsTitle2.default, { translate: _this.props.translate }) :
          _this.renderH2Title()));}, _temp), _possibleConstructorReturn(_this, _ret);}PropertyListTopBlock.prototype.




  render = function render() {
    return (
      _react2.default.createElement('div', { className: styles.titleSearchBox },
        _react2.default.createElement('div', { className: styles.h1Title },
          _react2.default.createElement('h1', null, this.props.transformDataForTitle()),
          !this.props.isMobile && (0, _get2.default)(this.props, 'routeData.location') !== 'projects' &&
          _react2.default.createElement('div', { className: styles.saveSearchContainer },
            _react2.default.createElement('button', { onClick: this.props.saveSearchLocation },
              this.props.translate('search_box', 'searchContainer', 'saveSearch')))),




        this.renderPropertyOptionsSwitch(),
        this.props.propertiesQuantity || this.props.projectsQuantity ? this.renderSortBlock() : null));


  };return PropertyListTopBlock;}(_react.Component);exports.default = PropertyListTopBlock;


PropertyListTopBlock.propTypes = {
  isMobile: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  propertiesQuantity: _propTypes2.default.number,
  projectsQuantity: _propTypes2.default.number,
  transformDataForTitle: _propTypes2.default.func,
  routeData: _propTypes2.default.object,
  searchProperty: _propTypes2.default.func,
  skip: _propTypes2.default.number,
  saveSearchLocation: _propTypes2.default.func,
  renderSwitch: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyListTopBlock/PropertyListTopBlock.js
// module id = 2849
// module chunks = 0